/** Normalize equivalent accents, letter case and spacing without changing punctuation. */
function normalizeSearchText(value: string): string {
  return value.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().trim().replace(/\s+/gu, ' ');
}

/** Match every literal query term somewhere across the available campaign fields. */
export function matchesCampaignSearch(query: string, fields: readonly string[]): boolean {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) return true;

  const normalizedFields = fields.map(normalizeSearchText);
  return normalizedQuery.split(' ').every((term) => normalizedFields.some((field) => field.includes(term)));
}
